import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addCropVariety, updateCropVariety } from '../cropVarietiesSlice';
import { CropVariety } from '../../../types/cropVarieties';
import { useFormValidation } from '../../../hooks/useFormValidation';

interface VarietyFormValues {
  name: string;
  description?: string;
}

export const useVarietyForm = (
  onSuccess: () => void,
  initialVariety?: CropVariety
) => {
  const dispatch = useDispatch();
  const [submitError, setSubmitError] = useState<string | null>(null);

  const { values, errors, handleChange, handleSubmit, isValid, isSubmitting } = useFormValidation(
    {
      name: initialVariety?.name || '',
      description: initialVariety?.description || '',
    },
    {
      name: (value) => (!value ? 'Variety name is required' : ''),
    },
    async (values) => {
      try {
        if (initialVariety) {
          await dispatch(updateCropVariety({ id: initialVariety.id, ...values }));
        } else {
          await dispatch(addCropVariety(values));
        }
        onSuccess();
      } catch (error) {
        setSubmitError(error instanceof Error ? error.message : 'Failed to save variety');
        throw error;
      }
    }
  );

  return {
    values,
    errors,
    handleChange,
    handleSubmit,
    isValid,
    isSubmitting,
    submitError
  };
};